// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { MainWindowManager } from "../../UtilsClasses/MainWindowManager.js";
import { Resources } from "../../../Commons/properties/Resources.ts";
import { Control } from "../Control.js";
import { TerceraDateSelectorDropDown } from "./TerceraDateSelectorDropDown.js";
import { DateTimeUtils } from "../../../Utils/Time/DateTimeUtils.ts";
import { TerceraLookup } from "./TerceraLookup.js";
export let TerceraDateSelectorLookup = TerceraLookup.extend({
    data: function ()
    {
        return {
            btnClass: "js-lookup-datetime",
            btnName: "dateTimeLookup",
            name: "TerceraDateSelectorLookup",
            expirationTime: new Date(),
            isReadOnly: true,
            canSelect: false
        }
    },
    selectedDate: null,
});

TerceraDateSelectorLookup.prototype.getType = function () { return 'TerceraDateSelectorLookup' };

TerceraDateSelectorLookup.prototype.showForm = function ()
{
    var dropDownForm = new TerceraDateSelectorDropDown()
    dropDownForm.setCorrectLocation(this.getX(), this.getY());
    MainWindowManager.MainWindow.addControl(dropDownForm);

    dropDownForm.on("timeSelectorLookupClosed", function ()
    {
        this.fire("timeSelectorLookupClosed")
    }.bind(this))
    dropDownForm.observe("date", function (newD, oldD)
    {
        if (newD)
            this.set("expirationTime", newD)
    }.bind(this), { init: false })
    dropDownForm.set("date", this.get("expirationTime"))
    this.fire("timeSelectorLookupOpened")
};

TerceraDateSelectorLookup.prototype.oninit = function ()
{
    TerceraLookup.prototype.oninit.apply(this);

    this.repopulate();
};

TerceraDateSelectorLookup.prototype.oncomplete = function ()
{
    TerceraLookup.prototype.oncomplete.apply(this);
    this.observe("expirationTime", function (newValue)
    {
        this.repopulate(newValue)
    })
    this.textBox.on(Control.Events.GotFocus, function () { this.showForm(); }.bind(this));
};

TerceraDateSelectorLookup.prototype.getButtonTooltip = function ()
{
    return Resources.getResource('screen.Alerts.Label.Expiration.Tooltip');
};

TerceraDateSelectorLookup.prototype.repopulate = function (newD)
{
    if (newD)
        this.setItems({ text: DateTimeUtils.formatDate(newD, "DD.MM.YYYY HH:mm") });
    else
        this.setItems({ text: "No Data" });

    this.setSelectValue(this.items[0])
};